<template>

<div :class="[ 'single', { 'is-hidden': singleIsHidden }]">

    <single-header :project="project">
        <p>Droplet let's you list your projects with infos like client, date
        and what language or framework it runs on. It even supports writing
        project notes in Markdown. An advanced search function is included
        to quickly find the project you are looking for.</p>

    </single-header>

    <!-- SECTION -->

    <single-section header="Login Info" info :color="project.color">

        <p>To log into the demo use the following credentials:<br>
        <br>
        <b>Username:</b> pk<br>
        <b>Password:</b> pk</p>

    </single-section>

    <!-- SECTION -->

    <single-section header="Basic Authentication">

        <p>To prevent outsiders to log into the app and manipulate the tables
        you need to log in. The process is handled dynamically with AJAX and
        accompanied by smooth transitions.</p>

        <video src="assets/projects/droplet/login.mp4" autoplay loop></video>

    </single-section>

    <!-- SECTION -->

    <single-section header="Creating a Project">

        <p>Notes can be written in Markdown to support basic formatting.</p>

        <img src="assets/projects/droplet/edit-project.jpg">

    </single-section>

    <!-- SECTION -->

    <single-section header="Navigating the Tables">

        <p>Shortcuts and in place for easy and fast navigation through the tables
        and the project creation process. Using the arrow keys moves horizontally and
        vertically through the tables &mdash; walking through the projects.
        Hitting CMD + N opens the modal for a new project.</p>

        <video src="assets/projects/droplet/table-navigation.mp4" autoplay loop></video>

    </single-section>



    <!-- SECTION -->

    <single-section header="Automatic Project Creation" info :color="project.color">

        <p>A planned feature is automatically creating a Droplet project
        when generating the project readme locally by running a Node script.<br>
        The script will ask the user in the terminal all the needed infos and uploads
            the data with the help of the Laravel API into the database.</p>

        <img :src="require('Projects/droplet/terminal-feature.png')" alt="Terminal asking Project Data">

    </single-section>


</div>

</template>

<script>
import { singleHandler } from '@/modules/mixins'

export default {
    data() {
        return {
            project: {
                title: 'Droplet',
                subtitle: 'Simple Project Manager',
                logoSuffix: 'png',
                background: 'linear-gradient(45deg, #43b9c6, #7b99d6)',
                color: '#7b99d6',
                role: 'Management',
                features: 'Vue, Laravel, database-driven',
                url: 'https://droplet.artofmyself.com'
            }
        }
    },

    mixins: [singleHandler]
}
</script>



// WEBPACK FOOTER //
// droplet.vue?11c26c66